export default "__VITE_ASSET__DgvBtKhH__"